import { Tag } from '@cian/components';
import * as React from 'react';

import { ICeilingHeightTag } from '../../../state/tags/definitions/ceiling_height';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface ICeilingHeightTagItemProps {
  tag: ICeilingHeightTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const CeilingHeightTagItem = ({ tag, onDeleteClick, withNewTag }: ICeilingHeightTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);
  let text = [];

  if (tag.min !== undefined) {
    text.push(`от ${tag.min}`);
  }

  if (tag.max !== undefined) {
    text.push(`до ${tag.max}`);
  }

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      Высота потолков {text.join(' ')} м
    </TagComponent>
  );
};
